import api from "./ApiURLBase";
const EndPointGetRoutesList = async () =>
  await api.get(`/routes/GetRoutesList`);

const EndPointGetRoutes = async (miningSite) => await api.get(`/routes/GetRoute?miningSiteId=${miningSite}`);
const EndPointGetRoutesEspecific = async (id) =>
  await api.get(`/routes/GetRoute?routeIdReq=${id}`);

const EndPointCreateUpdateRoute = async (data) =>
  await api.post(`/routes/CreateUpdateRoute`, data);

const EndPointDeleteRoute = async (id, miningSite) =>
  await api.delete(`/routes/DeleteRoute?routeIdReq=${id}&miningSiteId=${miningSite}`);

const EndPointGetRouteScheduleInfo = async (routeId, miningSiteId) =>
  await api.get(`/routes/GetRouteScheduleInfo?routeId=${routeId}&miningSiteId=${miningSiteId}`);

export {
  EndPointGetRoutesList,
  EndPointGetRoutes,
  EndPointCreateUpdateRoute,
  EndPointDeleteRoute,
  EndPointGetRoutesEspecific,
  EndPointGetRouteScheduleInfo,
};
